import { createReducer, on } from '@ngrx/store';
import { predefinedPricingTiersActions } from '../actions/predefined-pricing-tiers.actions';
import { PredefinedPricingTier } from '../models';

export interface PredefinedPricingTiersState {
    loaded: boolean | null;
    loading: boolean;
    saving: boolean;
    saved: boolean;
    tiers: PredefinedPricingTier[];
}

export const initialState: PredefinedPricingTiersState = {
    loaded: null,
    loading: false,
    saving: false,
    saved: false,
    tiers: [],
};

export const predefinedPricingTiersReducer = createReducer(
    initialState,
    // Get
    on(predefinedPricingTiersActions.getTiers, (state): PredefinedPricingTiersState => ({
        ...state,
        loading: true,
        loaded: null,
    })),
    on(predefinedPricingTiersActions.getTiersSuccess, (state, { payload }): PredefinedPricingTiersState => ({
        ...state,
        loading: false,
        loaded: true,
        tiers: payload,
    })),
    on(predefinedPricingTiersActions.getTiersError, (state): PredefinedPricingTiersState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Save full list
    on(predefinedPricingTiersActions.saveTiers, (state): PredefinedPricingTiersState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(predefinedPricingTiersActions.saveTiersSuccess, (state, { payload }): PredefinedPricingTiersState => ({
        ...state,
        saving: false,
        saved: true,
        tiers: payload,
    })),
    on(predefinedPricingTiersActions.saveTiersError, (state): PredefinedPricingTiersState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Clear
    on(predefinedPricingTiersActions.clear, (): PredefinedPricingTiersState => ({ ...initialState })),
);
